import React, {useState, useEffect, useContext} from 'react';

import Layout from './layout';
import api from '../../services/api';

import AppContext from '../../redux/contexts/appContext'


function Home() {
  const [cards, setCards] = useState([])
  const [loading, setLoading] = useState(true);
  const [loadingItemAmount, setLoadingItemAmount] = useState(new Array(3, null));
  const {state, dispatch} = useContext(AppContext);

  const loadCards = () => {
    // Getting user associated rooms
    if (!state.user.token) {
      return false;
    }
    setCards([]);
    setLoading(true);
    let loadingAmount = localStorage.getItem("hic") || 0;
    let amountArray = [];
    for (let i = 0; i < loadingAmount; i++) {
      amountArray.push(i);
    }
    setLoadingItemAmount(amountArray);
    api().get('/user/'+state.user.id+"/rooms", {headers: {'Authorization': "Bearer "+state.user.token}})
    .then(response => {
      var items = response.data.result;
      localStorage.setItem("hic", items?.all?.length || 0);
      setLoading(false);
      setCards(items);
    })
    .catch(err => {
      setLoading(false);
    })
  }

  const removeCard = (id) => {
    var newItems = JSON.parse(JSON.stringify(cards));
    newItems.yourRooms = newItems.yourRooms.filter(item => item._id !== id);
    newItems.sharedWithYou = newItems.sharedWithYou.filter(item => item._id !== id);
    newItems.all = newItems.all.filter(item => item._id !== id);
    setCards(newItems);
  }
  
  useEffect(() => {
    loadCards();
  }, [])

  return (
      <Layout
        loading={loading}
        loadingAmount={loadingItemAmount}
        onRoomRemove={removeCard}
        cards={cards}
      />
  );
}

export default Home;